import './App.css';
import { BrowserRouter, Route, Switch } from "react-router-dom";
// import ScrollToTop from "../hooks/ScrollToTop";
import { QueryClient, QueryClientProvider } from "react-query";
// import ProtectedApp from "./ProtectedApp";
import Home from "./pages/Home";
import Galerie from './pages/Galerie';
import Qsn from './pages/Qsn';
import Login from './pages/Login';
import Contact from './pages/Contact';
import EvenementsIncoming from './pages/EvenementsIncoming';
import EvenementsPasses from './pages/EvenementsPasses';
import EvenementsExternal from './pages/EvenementsExternal';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import ProtectedApp from "./components/ProtectedApp";
import { UserContextProvider } from "./userContext/userContext";
import * as API from "./services/API";
import LegalNotice from './pages/LegalNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';

function createVisitorId() {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  if (window.crypto?.getRandomValues) {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, "0"));
    return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex
      .slice(6, 8)
      .join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10, 16).join("")}`;
  }

  return `visitor-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function getVisitorId() {
    let id = localStorage.getItem("visitor_id");
    let date = localStorage.getItem("visitor_last_date");
    
    Date.prototype.addDays=function(d){return new Date(this.valueOf()+864E5*d);};
    // console.log(new Date(date).addDays(1));
    // console.log(new Date());
    // console.log(new Date(date).addDays(1) < new Date());

    if (!id || !date || date === null || new Date(date).addDays(1) < new Date()) {
      
      if(!date || date === null || !id) {
        id = createVisitorId();
        localStorage.setItem("visitor_id", id);
        localStorage.setItem("visitor_last_date", new Date());
        API.visitorTrackerRequest(id,()=>{},()=>{});
      }else{
        localStorage.setItem("visitor_last_date", new Date());
        API.visitorTrackerRequest(id,()=>{},()=>{});
      }
      
    }
    return id;
}
function App() {
  const queryClient = new QueryClient();
  // Used to keep connexion alive (using page refresh)

  getVisitorId();


  return (
    <UserContextProvider>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/home" component={Home} />
          <Route exact path="/presentation" component={Qsn} />
          <Route exact path="/galerie" component={Galerie} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/evenements/a-venir" component={EvenementsIncoming} />
          <Route exact path="/evenements/passes" component={EvenementsPasses} />
          <Route exact path="/evenements/external" component={EvenementsExternal} />
          <Route exact path="/reset-password" component={ResetPassword} />
          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/signup" component={Login} />
          <Route exact path="/mentions-legales" component={LegalNotice} />
          <Route exact path="/politique-confidentialite" component={PrivacyPolicy} />

          {/* <Route exact path="/initpassword/:src" component={ReinitPassword} /> */}
          <QueryClientProvider client={queryClient}>
            <ProtectedApp />
          </QueryClientProvider>
        </Switch>
      </BrowserRouter>
    </UserContextProvider>
  );
}

export default App;
